import {mixins} from "../app/mixin";

mixins.push({
    el: '.jobOpeningsPage',
    delimiters: ['${', '}'],
    data() {
        return {
            searchQuery: '',
            departmentFilters: [],
            jobTypeFilters: [],
            titleFilters: [],
            filteredJobs: [],
            pagedJobs: [],
            jobs: window.jobs,
            totalPages: 0,
            isFilterCardOpen: false,
            showingText: '',
            selectedPage: 1,
            filterText: window.filterText,
            singleFilterText: window.singleFilterText,
        }
    },
    mounted() {
        this.filteredJobs = this.jobs.map(o => o.id);
        this.totalPages = Math.floor(this.filteredJobs.length / 10) + 1
        this.pagedJobs = this.filteredJobs.slice(0, 10);
        this.calcShowingText();
    },
    methods: {
        filter() {
            this.filteredJobs = this.jobs.filter(o =>
                (this.searchQuery === '' || o.title.toLowerCase().includes(this.searchQuery))
                && (this.titleFilters.length === 0 || this.titleFilters.includes(o.title))
                && (this.jobTypeFilters.length === 0 || this.jobTypeFilters.some(jtf => o.jobTypes.map(jt => jt.code).includes(jtf)))
                && (this.departmentFilters.length === 0 || this.departmentFilters.includes(o.department.id))
            ).map(o => o.id);

            this.pagedJobs = this.filteredJobs.slice(0, 10);
            this.totalPages = Math.floor(this.filteredJobs.length / 10) + 1
            this.calcShowingText();
        },
        setTitleFilter(title) {
            if (this.titleFilters.includes(title)) {
                this.titleFilters = this.titleFilters.filter((item) => item !== title)
            } else {
                this.titleFilters.push(title);
            }

            this.filter();
        },
        setDepartmentFilter(department) {
            if (this.departmentFilters.includes(department)) {
                this.departmentFilters = this.departmentFilters.filter((item) => item !== department)
            } else {
                this.departmentFilters.push(department);
            }

            this.filter();
        },
        setJobTypeFilter(jobType) {
            if (this.jobTypeFilters.includes(jobType)) {
                this.jobTypeFilters = this.jobTypeFilters.filter((item) => item !== jobType)
            } else {
                this.jobTypeFilters.push(jobType);
            }

            this.filter();
        },
        searchByQuery(query) {
            this.searchQuery = query.toLowerCase();

            this.filter();
        },
        changePage(page) {
            this.pagedJobs = this.filteredJobs.slice((page - 1) * 10, page * 10);
            this.selectedPage = page;

            this.calcShowingText();
        },
        calcShowingText() {
            if (this.filteredJobs.length > 1) {
                this.showingText = this.filterText.replace('$1', (((this.selectedPage - 1) * 10) + 1))
                    .replace('$2', (this.selectedPage * 10))
                    .replace('$3', this.filteredJobs.length);
            } else {
                this.showingText = this.singleFilterText;
            }
        },
        toggleFilterCard() {
            this.isFilterCardOpen = !this.isFilterCardOpen;
        },
    }
});